export default "__VITE_ASSET__B3OcEK_M__"